export default function FeatureService($http, appSettings) {
  'ngInject';
  return {
    getFeatures: function () {
      const endpoint = `${appSettings.InReachApiEndpoint}/features`;
      return $http.get(endpoint);
    }
  };
}